import React from "react";
import BoxItemCard from "./parts/BoxItemCard";
import BoxItemHeader from "./parts/BoxItemHeader";
import BoxItemImage from "./parts/BoxItemImage";
import BoxItemSkuInfo from "./parts/BoxItemSkuInfo";
import { IRestockItemUI } from "../../../lib/interfaces/ConveyorBox/IConveyorBox";
import { BoxItemAssignedShelfNumber } from "./parts/BoxItemAssignedShelf";
import { Progress } from "semantic-ui-react";
import BoxItemRibbon from "./parts/BoxItemRibbon";

type Props = {
  item: IRestockItemUI;
  isSelected: boolean;
};

const RestockItem = ({ item, isSelected }: Props) => {
  const {
    article,
    attributes,
    sku,
    varunummer,
    isRestocked,
    operatorAssignedShelf,
    quantityVerified,
    quantity,
  } = item;
  return (
    <BoxItemCard isSelected={isSelected}>
      {/* <BoxItemOverlays isCancelled /> */}
      <CancelledItemRibbon isRestocked={isRestocked} isSelected={isSelected} />
      <BoxItemHeader title={article.name} attributes={attributes} />
      <BoxItemImage imageUrl={article.imageUrl} />
      <BoxItemSkuInfo skuId={sku.id} weight={article.weight} varunummer={varunummer} />
      {isRestocked ? (
        <BoxItemAssignedShelfNumber shelf={operatorAssignedShelf} quantity={quantityVerified} />
      ) : (
        <Progress
          size="large"
          value={quantityVerified}
          total={quantity}
          progress="ratio"
          color={"blue"}
          active={quantityVerified < quantity}
        ></Progress>
      )}
    </BoxItemCard>
  );
};

export const CancelledItemRibbon = ({
  isRestocked,
  isSelected,
}: {
  isRestocked: boolean;
  isSelected: boolean;
}) => {
  if (isRestocked) return <BoxItemRibbon text="Inskannad" type="success" />;
  else if (isSelected) return <BoxItemRibbon text="Hanteras" type="default" />;
  else return <BoxItemRibbon text="Avbruten" type="danger" />;
};

export default RestockItem;
